export default "__VITE_ASSET__0b2e6dd6__"